import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";
import InputForm from "../../../../Misc/InputForm";
import GroupUsers from "./GroupUsers";

export default class Group extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      mode: "view",
    };
  }

  deleteClick = () => {
    let item = this.props.item || {};
    this.context
      .ask(
        `Вы действительно хотите удалить группу ${item.id} ${item.name}`,
        "Удаление группы",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete();
        }
      });
  };

  delete = async () => {
    this.setState({ pending: true });
    let item = this.props.item || {};
    let result = await this.context.api.q("/admin/group/delete", {
      id: item.id,
    });
    if (result !== false) {
      this.context.toast(`${item.name}: Группа удалена`, "success");
      this.props.onFinish();
    } else {
      this.context.toast(`${item.name}: Не удалось удалить группу`, "error");
    }

    this.setState({ pending: false, mode: "view" });
  };

  save = async (data) => {
    if (this.state.mode === "edit") data.id = this.props.item["id"];

    this.setState({ pending: true });
    let result = await this.context.api.q("/admin/group/set", data);
    if (result !== false) {
      let id = result["id"] ? String(result["id"]) : false;
      this.context.toast("Профиль группы сохранен", "success");
      this.props.onFinish(id);
    } else {
      this.context.toast("Не удалось сохранить профиль группы", "error");
    }
    this.setState({ pending: false, mode: "view" });
  };

  changeMode = (mode) => {
    let newMode = mode;
    if (this.state.mode === newMode) newMode = "view";
    this.setState({ mode: newMode });
  };

  componentDidMount() {
    this.context.actionsSet(this.renderButtons());
  }
  componentDidUpdate() {
    this.context.actionsSet(this.renderButtons());
  }

  renderEdit() {
    let item = this.props.item || false;
    if (!item) return null;
    return (
      <>
        <InputForm
          fields={{
            username: {
              title: "Код",
              type: "text",
              validate: true,
              error: false,
              default: "",
            },
            name: {
              title: "Наименование",
              type: "text",
              validate: true,
              error: false,
              default: "",
            },
            description: {
              title: "Описание",
              type: "text",
              validate: false,
              error: false,
              default: "",
            },
          }}
          data={item}
          key={item.id}
          onSubmit={this.save}
          onCancell={() => this.changeMode("view")}
        />
      </>
    );
  }

  renderAdd() {
    let item = {};
    return (
      <>
        <InputForm
          fields={{
            username: {
              title: "Код",
              type: "text",
              validate: true,
              error: false,
              default: "",
            },
            name: {
              title: "Наименование",
              type: "text",
              validate: true,
              error: false,
              default: "",
            },
            description: {
              title: "Описание",
              type: "text",
              validate: false,
              error: false,
              default: "",
            },
          }}
          data={item}
          key={item.id}
          onSubmit={this.save}
          onCancell={() => this.changeMode("view")}
        />
      </>
    );
  }

  renderView() {
    let item = this.props.item || false;
    if (!item) return null;
    return (
      <>
        <table className="table w-100">
          <tbody>
            <tr>
              <td width="25%">Id</td>
              <td>
                {item.id}
                {this.isSystem() ? (
                  <span className="label label-inline ml-3">
                    Системная группа
                  </span>
                ) : null}
              </td>
            </tr>
            <tr>
              <td>Код</td>
              <td>{item.username}</td>
            </tr>
            <tr>
              <td>Наименование</td>
              <td>{item.name}</td>
            </tr>
            <tr>
              <td>Описание</td>
              <td>{item.description}</td>
            </tr>
          </tbody>
        </table>
      </>
    );
  }

  isSystem = () => {
    let item = this.props.item || {};
    return item.system === "yes";
  };

  renderButtons() {
    let editable = this.props.item && !this.isSystem();
    return (
      <div className="text-nowrap">
        {editable ? (
          <button
            onClick={() => this.changeMode("edit")}
            className={`btn ${
              this.state.mode === "edit" ? "btn-light-primary" : "btn-light"
            } p-2 mr-2`}
          >
            <span className="flaticon2-edit px-2 align-middle"></span>
          </button>
        ) : null}

        <button
          onClick={() => this.changeMode("add")}
          className={`btn ${
            this.state.mode === "add" ? "btn-light-primary" : "btn-light"
          } p-2  mr-2`}
        >
          <span className="flaticon2-add-1 px-2 align-middle"></span>
        </button>

        {editable ? (
          <button
            onClick={this.deleteClick}
            className={"btn btn-light p-2 text-hover-danger"}
          >
            <span className="flaticon2-rubbish-bin px-2 align-middle"></span>
          </button>
        ) : null}
      </div>
    );
  }

  render() {
    let item = this.props.item || {};
    let title = item.name;
    if (this.state.mode === "add") title = "Добавление группы";

    if (!this.props.item && this.state.mode !== "add") {
      return (
        <div className="d-flex justify-content-center align-items-center h-100"></div>
      );
    }

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="d-flex justify-content-between align-items-center mb-10">
            <h6 className="text-muted  ">{title}</h6>
          </div>
          {this.state.mode === "view" ? this.renderView() : null}
          {this.state.mode === "edit" ? this.renderEdit() : null}
          {this.state.mode === "add" ? this.renderAdd() : null}
          <GroupUsers id={item["id"]} key={item["id"]} item={item} />
        </Blocker>
      </>
    );
  }
}
